import React, { FC } from "react";

import { TextField, TextFieldProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(TextField)(({ theme }) => ({}));

/**
 * @see TextField
 */
export const IgTextField: FC<TextFieldProps> = (props) => {
  const { children, ...rest } = props;

  return <StyledTextField {...rest}>{children}</StyledTextField>;
};
